export const getUiBridge = () => window.ReactGwtBridge;

export const executeUI = (moduleName, actionType, ...args) => {
    return getUiBridge().onBtnClicked(moduleName, actionType, ...args);
};